/** Generated by syncRemoteAssets.js - DO NOT EDIT */
import assets from './assets.json';

// 动态导入 SVG 资源
import Matrix_Logo from './remote/svg/Matrix_Logo';
import Daily_Check_Little_start from './remote/svg/Daily_Check_Little_start';
import Daily_Check_Last_Fast from './remote/svg/Daily_Check_Last_Fast';
import VIP_Tag_Svg from './remote/svg/VIP_Tag_Svg';
import Plus_Tag_Svg from './remote/svg/Plus_Tag_Svg';
import Loading_Transparency_Logo from './remote/svg/Loading_Transparency_Logo';
import Privacy_App_Icon from './remote/svg/Privacy_App_Icon';

// 动态导入 JSON 资源
import Google_Services from './remote/json/Google_Services';

const svgResources = {
  Matrix_Logo,
  Daily_Check_Little_start,
  Daily_Check_Last_Fast,
  VIP_Tag_Svg,
  Plus_Tag_Svg,
  Loading_Transparency_Logo,
  Privacy_App_Icon,
};

const jsonResources = {
  Google_Services,
};

export const matrixAssets = {
  ...assets,
  svg: svgResources,
  json: jsonResources,
};

export default matrixAssets;
